import type { ReactNode } from 'react';

export interface TopicItem {
  id: number;
  name: string;
  heat: string;
  trend: 'up' | 'down' | 'hot';
  tag?: string;
}

export interface UpdateItem {
  id: number;
  date: string;
  time: string;
  title: string;
  summary: string;
  category: string;
}

export interface FeatureItem {
  id: number;
  icon: string;
  title: string;
  description: string;
}

export interface AppItem {
  title: string;
  description: string;
  features: string[];
  platforms: { name: string; icon: string }[];
}

export interface FaqItem {
  id: number;
  question: string;
  answer: string;
}

export interface CardItem {
  id: number;
  image: string;
  category: string;
  title: string;
  excerpt: string;
  date: string;
  views: string;
}

export interface MediaItem {
  id: number;
  thumbnail: string;
  duration: string;
  title: string;
  views: string;
  date: string;
}

export interface IndexItem {
  id: number;
  icon: string;
  title: string;
  count: number;
  description: string;
}

export interface RankingItem {
  rank: number;
  title: string;
  heat: string;
  change: 'up' | 'down' | 'same' | 'new';
  category: string;
}

export interface CarouselItem {
  id: number;
  image: string;
  tag: string;
  title: string;
  description: string;
  link: string;
}

export interface CommentItem {
  id: number;
  avatar: string;
  username: string;
  date: string;
  content: string;
  likes: number;
  tag?: string;
}

export interface AboutData {
  title: string;
  description: string;
  stats: { label: string; value: string }[];
}

export interface SiteData {
  siteName: string;
  topics: TopicItem[];
  updates: UpdateItem[];
  features: FeatureItem[];
  app: AppItem;
  faq: FaqItem[];
  cards: CardItem[];
  media: MediaItem[];
  indexItems: IndexItem[];
  ranking: RankingItem[];
  carousel: CarouselItem[];
  comments: CommentItem[];
  about: AboutData;
}

export const siteData: SiteData = {
  siteName: '黑料',
  topics: [
    { id: 1, name: '明星塌房', heat: '9.8万', trend: 'hot', tag: '爆' },
    { id: 2, name: '恋情曝光', heat: '8.2万', trend: 'up', tag: '热' },
    { id: 3, name: '综艺翻车', heat: '7.5万', trend: 'up' },
    { id: 4, name: '剧组内幕', heat: '6.9万', trend: 'hot', tag: '新' },
    { id: 5, name: '代言风波', heat: '6.3万', trend: 'down' },
    { id: 6, name: '音乐圈大瓜', heat: '5.8万', trend: 'up' },
    { id: 7, name: '网红翻车', heat: '5.2万', trend: 'hot' },
    { id: 8, name: '选秀黑幕', heat: '4.7万', trend: 'up' },
    { id: 9, name: '导演潜规则', heat: '4.3万', trend: 'down' },
    { id: 10, name: '明星税务', heat: '3.9万', trend: 'up' },
    { id: 11, name: '综艺剧本泄露', heat: '3.5万', trend: 'hot' },
  ],
  updates: [
    {
      id: 1, date: '07-20', time: '14:32',
      title: '知名男星深夜密会神秘女子，疑似新恋情浮出水面',
      summary: '据可靠消息，某顶流男星被拍到与一神秘女子在某高档餐厅共进晚餐，两人举止亲密，随后一同返回住处。',
      category: '恋情曝光',
    },
    {
      id: 2, date: '07-20', time: '11:15',
      title: '某综艺录制现场突发状况，导演组与嘉宾爆发激烈争执',
      summary: '现场工作人员透露，因剧本安排问题，某常驻嘉宾当场发飙，导致录制中断近两小时。',
      category: '综艺翻车',
    },
    {
      id: 3, date: '07-19', time: '22:40',
      title: '品牌方连夜删博，知名女星代言疑似被撤',
      summary: '多个品牌官方账号已悄然删除与其相关的所有宣传内容，疑似因近期负面舆论导致合作终止。',
      category: '代言风波',
    },
    {
      id: 4, date: '07-19', time: '18:05',
      title: '新剧拍摄现场路透曝光，剧情疑似魔改原著引争议',
      summary: '路人拍摄的剧组现场照片显示剧情走向与原著差异巨大，书粉已在社交平台发起抵制话题。',
      category: '剧组内幕',
    },
    {
      id: 5, date: '07-19', time: '09:30',
      title: '音乐节后台独家爆料，两位实力歌手疑似不和已久',
      summary: '据现场工作人员描述，两人全程零交流，休息室被刻意安排在不同区域，团队之间火药味十足。',
      category: '音乐圈大瓜',
    },
    {
      id: 6, date: '07-18', time: '16:22',
      title: '头部网红直播带货数据造假被实锤，平台已启动调查',
      summary: '第三方数据监测机构出具报告显示该网红直播间真实观众不足宣称数据的十分之一。',
      category: '网红翻车',
    },
    {
      id: 7, date: '07-18', time: '10:08',
      title: '某影视公司内部邮件泄露，多位艺人合同条款被曝光',
      summary: '泄露邮件显示该公司与旗下艺人签订的"霸王条款"涉及收入分成、人身限制等多方面不合理规定。',
      category: '娱乐圈内幕',
    },
  ],
  features: [
    {
      id: 1,
      icon: 'ri-flashlight-line',
      title: '一手爆料',
      description: '遍布娱乐圈的线索网络，第一时间获取最新内幕消息，让你走在吃瓜最前线，不错过任何一个大瓜。',
    },
    {
      id: 2,
      icon: 'ri-group-line',
      title: '活跃社区',
      description: '百万吃瓜群众在线互动，实时讨论最新爆料话题，分享独家信息，打造最大的中文娱乐圈交流社区。',
    },
    {
      id: 3,
      icon: 'ri-shield-check-line',
      title: '信息甄别',
      description: '专业团队多源交叉验证，标注信息来源可信度，帮你过滤虚假信息，只推送有据可查的真实爆料。',
    },
    {
      id: 4,
      icon: 'ri-smartphone-line',
      title: '全平台覆盖',
      description: '支持网页、手机App多端同步，黑料不打烊，随时随地追最新吃瓜动态，永不断联。',
    },
  ],
  app: {
    title: '黑料App — 吃瓜不停歇',
    description: '下载黑料官方App，享受更流畅的吃瓜体验。推送更快、社区更近、视频更清晰，黑料不打烊，随时随地在线吃瓜。',
    features: ['实时推送最新爆料', '高清视频流畅播放', '社区互动零延迟', '夜间模式护眼吃瓜'],
    platforms: [
      { name: 'iOS 下载', icon: 'ri-apple-fill' },
      { name: 'Android 下载', icon: 'ri-android-fill' },
    ],
  },
  faq: [
    {
      id: 1,
      question: '黑料是什么网站？',
      answer: '黑料是一个专注于娱乐圈内幕爆料的资讯平台，提供每日最新吃瓜爆料视频、明星动态追踪、娱乐圈深度揭秘等内容。平台集成了黑料社区互动功能，用户可以在这里讨论最新爆料话题，是中文互联网最大的娱乐八卦聚集地之一。',
    },
    {
      id: 2,
      question: '如何找到黑料官网最新入口？',
      answer: '由于黑料内容涉及娱乐圈敏感内幕，域名可能会不定期更新。建议收藏本页面作为黑料官网入口导航，或下载黑料App获取稳定的访问通道。本站会持续更新最新可用地址，确保黑料不打烊，让你随时在线观看。',
    },
    {
      id: 3,
      question: '黑料社区如何参与互动？',
      answer: '注册黑料账号后即可在社区发帖、评论和点赞。黑料社区采用积分等级制度，活跃用户可以获得更高的曝光权重。发布独家爆料内容的用户有机会获得"爆料达人"认证标识。',
    },
    {
      id: 4,
      question: '黑料App与网页版有什么区别？',
      answer: '黑料App相比网页版拥有更快的推送速度、更流畅的视频播放体验和更完整的社区功能。App支持离线缓存吃瓜内容、自定义推送分类以及专属的夜间模式。网页版则无需安装，适合快速浏览最新爆料。',
    },
    {
      id: 5,
      question: '网站上的爆料内容可信吗？',
      answer: '黑料平台上的信息来自多种渠道，包括用户投稿、媒体线索和内部人士透露。我们会对每条爆料进行多源交叉验证，并根据可信度进行标注。建议用户理性看待所有内容，以官方信息为准。',
    },
  ],
  cards: [
    {
      id: 1,
      image: 'https://readdy.ai/api/search-image?query=Dramatic%20backstage%20scene%20of%20a%20film%20set%20with%20mysterious%20atmosphere%2C%20warm%20golden%20light%20spilling%20through%20curtains%2C%20cinematic%20composition%2C%20editorial%20photography%2C%20dark%20silhouette%20against%20warm%20light%2C%20behind%20the%20scenes%20entertainment%20industry%20aesthetic%2C%20rich%20amber%20and%20deep%20shadow%20tones&width=800&height=500&seq=card-01&orientation=landscape',
      category: '深度爆料',
      title: '某顶流男星私生活混乱实锤？多位当事人联合发声',
      excerpt: '近日多方消息源交叉证实，某长期维持"好男人"人设的顶流男星私下生活作风与公众形象严重不符，多位圈内人士打破沉默...',
      date: '2026-07-20',
      views: '12.8万',
    },
    {
      id: 2,
      image: 'https://readdy.ai/api/search-image?query=Elegant%20award%20ceremony%20backstage%20with%20subtle%20tension%2C%20dramatic%20spotlight%20shadows%2C%20red%20carpet%20behind%20the%20scenes%2C%20entertainment%20industry%20insider%20moment%2C%20cinematic%20warm%20lighting%2C%20editorial%20style%20photography%2C%20mysterious%20atmosphere&width=800&height=500&seq=card-02&orientation=landscape',
      category: '独家揭秘',
      title: '颁奖礼后台惊天内幕：评审团成员涉嫌利益输送',
      excerpt: '内部人士向黑料独家透露，某重量级颁奖典礼的评审过程中存在严重的利益交换行为，多名获奖者的当选并非基于实力...',
      date: '2026-07-19',
      views: '9.6万',
    },
    {
      id: 3,
      image: 'https://readdy.ai/api/search-image?query=Two%20celebrities%20in%20heated%20argument%20on%20film%20set%2C%20dramatic%20tension%2C%20warm%20evening%20light%2C%20cinematic%20composition%2C%20entertainment%20gossip%20scene%2C%20behind%20the%20scenes%20drama%2C%20editorial%20photography%20style%2C%20rich%20contrast&width=800&height=500&seq=card-03&orientation=landscape',
      category: '剧组风云',
      title: '两大花旦片场正面交锋，导演左右为难欲辞导',
      excerpt: '据剧组工作人员匿名投稿，两位一线女演员因戏份分配问题在拍摄现场发生激烈争吵，整个剧组气氛降至冰点...',
      date: '2026-07-18',
      views: '8.3万',
    },
    {
      id: 4,
      image: 'https://readdy.ai/api/search-image?query=Luxury%20brand%20store%20with%20removed%20posters%20traces%20on%20wall%2C%20empty%20billboard%20frame%2C%20dramatic%20lighting%2C%20commercial%20street%20scene%2C%20warm%20golden%20hour%20light%2C%20editorial%20photography%2C%20mysterious%20brand%20scandal%20atmosphere&width=800&height=500&seq=card-04&orientation=landscape',
      category: '商业秘闻',
      title: '国际奢侈品牌紧急解约多名代言人，涉及金额超十亿',
      excerpt: '多家国际一线品牌在短短48小时内密集宣布与中国区代言人解约，业内人士分析此举或与即将曝光的重大负面有关...',
      date: '2026-07-17',
      views: '7.1万',
    },
    {
      id: 5,
      image: 'https://readdy.ai/api/search-image?query=Concert%20backstage%20with%20separated%20dressing%20rooms%2C%20cold%20atmosphere%20between%20two%20areas%2C%20dramatic%20contrast%20lighting%2C%20music%20industry%20tension%2C%20warm%20spotlight%20and%20dark%20shadows%2C%20editorial%20photography%2C%20behind%20the%20scenes&width=800&height=500&seq=card-05&orientation=landscape',
      category: '音乐圈',
      title: '顶流歌手演唱会后台独家照片流出，团队冲突细节曝光',
      excerpt: '黑料独家获取演唱会后台照片，显示两位合作歌手的团队被严格隔离在不同区域，整个后台气氛剑拔弩张...',
      date: '2026-07-16',
      views: '6.5万',
    },
    {
      id: 6,
      image: 'https://readdy.ai/api/search-image?query=Streaming%20studio%20with%20multiple%20screens%20showing%20fake%20viewer%20numbers%2C%20dim%20purple%20and%20warm%20lighting%2C%20live%20streaming%20scandal%20scene%2C%20digital%20manipulation%20atmosphere%2C%20editorial%20photography%2C%20mysterious%20tech%20drama&width=800&height=500&seq=card-06&orientation=landscape',
      category: '直播内幕',
      title: '头部主播数据造假产业链被起底，平台或将重拳整治',
      excerpt: '黑料调查发现直播带货行业存在完整的"数据注水"产业链，从机器人观众到虚假订单，一条龙服务明码标价...',
      date: '2026-07-15',
      views: '5.9万',
    },
  ],
  media: [
    {
      id: 1,
      thumbnail: 'https://readdy.ai/api/search-image?query=Paparazzi%20night%20shot%20of%20two%20celebrities%20entering%20luxury%20hotel%2C%20dramatic%20moody%20lighting%2C%20blurred%20motion%2C%20entertainment%20gossip%20atmosphere%2C%20cinematic%20noir%20style%2C%20warm%20street%20light%20contrast&width=640&height=360&seq=media-01&orientation=landscape',
      duration: '03:42',
      title: '实拍！某男星深夜与神秘女同回酒店全程',
      views: '28.6万',
      date: '2天前',
    },
    {
      id: 2,
      thumbnail: 'https://readdy.ai/api/search-image?query=Dramatic%20film%20set%20confrontation%20scene%20with%20crew%20members%20arguing%2C%20warm%20set%20lights%2C%20chaotic%20atmosphere%2C%20behind%20the%20scenes%20drama%2C%20cinematic%20documentary%20style%2C%20editorial%20photography&width=640&height=360&seq=media-02&orientation=landscape',
      duration: '05:18',
      title: '独家！某综艺录制现场导演与嘉宾对峙全记录',
      views: '21.3万',
      date: '3天前',
    },
    {
      id: 3,
      thumbnail: 'https://readdy.ai/api/search-image?query=Brand%20event%20with%20empty%20spokesperson%20stand%20and%20confused%20staff%2C%20luxury%20venue%2C%20dramatic%20warm%20lighting%2C%20last%20minute%20cancellation%20scene%2C%20editorial%20photography%2C%20mysterious%20corporate%20drama&width=640&height=360&seq=media-03&orientation=landscape',
      duration: '02:55',
      title: '品牌活动突发取消，代言人被封杀背后真相',
      views: '18.9万',
      date: '4天前',
    },
    {
      id: 4,
      thumbnail: 'https://readdy.ai/api/search-image?query=Music%20festival%20backstage%20with%20separated%20artist%20areas%20and%20tense%20staff%2C%20warm%20festival%20lights%2C%20dramatic%20night%20scene%2C%20entertainment%20industry%20rivalry%2C%20editorial%20photography%2C%20rich%20golden%20and%20dark%20contrast&width=640&height=360&seq=media-04&orientation=landscape',
      duration: '04:36',
      title: '音乐节后台暗流涌动，两大歌手团队差点动手',
      views: '15.2万',
      date: '5天前',
    },
  ],
  indexItems: [
    { id: 1, icon: 'ri-fire-line', title: '明星塌房专题', count: 47, description: '明星负面新闻、人设崩塌全记录' },
    { id: 2, icon: 'ri-heart-line', title: '恋情曝光合集', count: 32, description: '娱乐圈最新恋情、婚变动态追踪' },
    { id: 3, icon: 'ri-camera-line', title: '综艺翻车现场', count: 28, description: '综艺节目争议、冲突与幕后故事' },
    { id: 4, icon: 'ri-movie-line', title: '影视剧内幕', count: 35, description: '影视行业潜规则与剧组真实情况' },
    { id: 5, icon: 'ri-shopping-bag-line', title: '品牌代言风波', count: 21, description: '明星代言解约、品牌争议事件汇总' },
    { id: 6, icon: 'ri-music-line', title: '音乐圈大瓜', count: 19, description: '音乐节、演唱会、排行榜背后的故事' },
    { id: 7, icon: 'ri-live-line', title: '直播带货揭秘', count: 24, description: '网红直播行业内幕与数据造假揭秘' },
  ],
  ranking: [
    { rank: 1, title: '知名男星私生活混乱多位当事人联合发声', heat: '128,630', change: 'up', category: '明星塌房' },
    { rank: 2, title: '颁奖礼评审团涉嫌利益输送内幕揭秘', heat: '96,420', change: 'up', category: '娱乐圈内幕' },
    { rank: 3, title: '两大花旦片场正面交锋导演欲辞导', heat: '83,150', change: 'new', category: '剧组内幕' },
    { rank: 4, title: '国际品牌紧急解约多名代言人', heat: '71,890', change: 'up', category: '代言风波' },
    { rank: 5, title: '头部主播数据造假产业链被起底', heat: '59,300', change: 'down', category: '网红翻车' },
  ],
  carousel: [
    {
      id: 1,
      image: 'https://readdy.ai/api/search-image?query=Dramatic%20spotlight%20on%20empty%20red%20carpet%20stage%20with%20fallen%20microphone%2C%20dark%20theater%20background%2C%20entertainment%20scandal%20atmosphere%2C%20cinematic%20warm%20golden%20light%2C%20editorial%20photography%2C%20mysterious%20and%20tense%20mood&width=1200&height=600&seq=carousel-01&orientation=landscape',
      tag: '本周最热',
      title: '明星塌房季：盘点近期人设崩塌的顶流们',
      description: '从好男人到渣男，从清纯玉女到心机女星，我们整理了过去三个月人设崩塌最彻底的七位明星，带你了解他们不为人知的另一面。',
      link: '#cards',
    },
    {
      id: 2,
      image: 'https://readdy.ai/api/search-image?query=Celebrity%20couple%20walking%20apart%20on%20divided%20street%2C%20warm%20sunset%20light%2C%20dramatic%20separation%20symbolism%2C%20entertainment%20romance%20drama%2C%20cinematic%20composition%2C%20editorial%20photography%2C%20emotional%20atmosphere&width=1200&height=600&seq=carousel-02&orientation=landscape',
      tag: '深度策划',
      title: '娱乐圈恋情经济学：为什么明星恋爱越来越像生意',
      description: '从官宣到分手全程热搜，明星恋情已演变成一门精密的流量生意。我们深度解析娱乐圈恋情背后的商业逻辑与资本博弈。',
      link: '#topics',
    },
    {
      id: 3,
      image: 'https://readdy.ai/api/search-image?query=Multiple%20TV%20screens%20showing%20different%20reality%20shows%20with%20scripts%20visible%2C%20control%20room%20atmosphere%2C%20warm%20monitor%20glow%2C%20entertainment%20manipulation%20theme%2C%20editorial%20photography%2C%20dark%20room%20with%20screen%20lights&width=1200&height=600&seq=carousel-03&orientation=landscape',
      tag: '独家调查',
      title: '综艺剧本产业链：你以为的真实不过是一场戏',
      description: '黑料团队历时一个月深入调查综艺节目的剧本创作流程，揭开了选秀、恋爱、竞技等各类综艺背后精心设计的剧本产业链。',
      link: '#updates',
    },
    {
      id: 4,
      image: 'https://readdy.ai/api/search-image?query=Luxury%20brand%20billboard%20being%20covered%20with%20white%20cloth%2C%20busy%20shopping%20street%2C%20dramatic%20daytime%20lighting%2C%20brand%20scandal%20atmosphere%2C%20editorial%20photography%2C%20warm%20sunlight%2C%20commercial%20drama&width=1200&height=600&seq=carousel-04&orientation=landscape',
      tag: '商业内幕',
      title: '代言人暴雷指南：品牌方如何应对明星负面危机',
      description: '从签约到解约只需48小时？我们梳理了近年来最轰动的明星代言解约事件，拆解品牌方与明星之间的利益博弈与危机公关策略。',
      link: '#ranking',
    },
    {
      id: 5,
      image: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20gossip%20app%20in%20dark%20room%2C%20warm%20screen%20glow%20on%20face%2C%20late%20night%20entertainment%20news%20consumption%2C%20digital%20media%20age%2C%20editorial%20photography%2C%20intimate%20atmosphere%2C%20modern%20lifestyle&width=1200&height=600&seq=carousel-05&orientation=landscape',
      tag: '平台动态',
      title: '黑料社区年度报告：2026上半年最受关注的十大爆料',
      description: '基于黑料社区百万用户的互动数据，我们汇总了2026上半年讨论度最高、传播最广的十大娱乐爆料事件，数据告诉你真正的吃瓜焦点在哪里。',
      link: '#comments',
    },
  ],
  comments: [
    {
      id: 1,
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20simple%20warm%20studio%20background%2C%20natural%20lighting%2C%20casual%20expression%2C%20clean%20aesthetic%2C%20editorial%20portrait%20photography%2C%20soft%20warm%20tones&width=100&height=100&seq=avatar-01&orientation=squarish',
      username: '吃瓜少女小A',
      date: '2小时前',
      content: '天哪这个料也太劲爆了吧！我之前就感觉他不对劲，果然又翻车了。黑料的爆料速度真的一绝，每次都是首发！',
      likes: 2389,
      tag: '热门评论',
    },
    {
      id: 2,
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20simple%20warm%20studio%20background%2C%20natural%20lighting%2C%20friendly%20expression%2C%20clean%20aesthetic%2C%20editorial%20portrait%20photography%2C%20soft%20warm%20tones&width=100&height=100&seq=avatar-02&orientation=squarish',
      username: '圈内老司机',
      date: '5小时前',
      content: '作为在这个行业摸爬滚打了十年的人，我只能说这些爆出来的只是冰山一角。真正的内幕比你们想象的还要黑暗十倍。',
      likes: 1856,
    },
    {
      id: 3,
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20simple%20warm%20studio%20background%2C%20natural%20lighting%2C%20thoughtful%20expression%2C%20clean%20aesthetic%2C%20editorial%20portrait%20photography%2C%20soft%20warm%20tones&width=100&height=100&seq=avatar-03&orientation=squarish',
      username: '理性吃瓜人',
      date: '8小时前',
      content: '虽然很震惊，但还是建议大家理性看待。黑料的信息交叉验证做得不错，不过在没有官方确认之前，还是保持一点谨慎比较好。',
      likes: 1520,
    },
    {
      id: 4,
      avatar: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20man%20portrait%2C%20simple%20warm%20studio%20background%2C%20natural%20lighting%2C%20confident%20expression%2C%20clean%20aesthetic%2C%20editorial%20portrait%20photography%2C%20soft%20warm%20tones&width=100&height=100&seq=avatar-04&orientation=squarish',
      username: '娱乐观察员',
      date: '12小时前',
      content: '看完这篇文章我整个人都不好了。之前还给他们花了不少钱应援，现在想想真是被割韭菜。感谢黑料让我看清真相！',
      likes: 1298,
    },
    {
      id: 5,
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20simple%20warm%20studio%20background%2C%20natural%20lighting%2C%20surprised%20expression%2C%20clean%20aesthetic%2C%20editorial%20portrait%20photography%2C%20soft%20warm%20tones&width=100&height=100&seq=avatar-05&orientation=squarish',
      username: '深夜吃瓜人',
      date: '1天前',
      content: '每天睡前必刷黑料已经成了习惯，以前觉得八卦浪费时间，现在才发现这是在了解社会真相哈哈。黑料App真好用，推送超快！',
      likes: 987,
    },
  ],
  about: {
    title: '关于黑料',
    description: '黑料是国内领先的娱乐圈内幕资讯平台，致力于为中文互联网用户提供最新、最全、最真实的吃瓜爆料内容。我们拥有遍布娱乐圈各领域的线索网络，从影视剧组到音乐综艺，从明星私生活到品牌商业内幕，以最快速度为你呈现真相。平台自上线以来已累计服务数百万追求真相的吃瓜群众，每日更新数百条独家爆料与深度解析。在黑料社区，你可以与志同道合的朋友一起讨论最新话题，分享你的独家发现。我们坚持信息交叉验证，对每条爆料标注可信度等级，让你吃得明明白白。下载黑料App，随时随地在线观看最新爆料视频，黑料不打烊，天天有瓜吃。',
    stats: [
      { label: '日活用户', value: '500万+' },
      { label: '每日爆料', value: '300+' },
      { label: '社区帖子', value: '2000万+' },
    ],
  },
};